import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError,
  InternalAxiosRequestConfig,
} from "axios";
import { SERVER_URL } from "../config/index";
import { store } from "../redux/store";
import { setLoading, setLoggedIn, setUser } from "../redux/user/slice";
import { decryptData } from "@/utils/crypto";
import { Danger } from "@/components/core/Errors";
import { logoutUser } from "@/utils/helpers";

const request: AxiosInstance = axios.create({
  baseURL: SERVER_URL,
  timeout: 1000000,
});

let requests: AxiosRequestConfig[] = [];

interface ErrorResponseData {
  message: string;
}
request.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    // console.log("localData",localStorage.getItem("token"))
    const token = decryptData(localStorage.getItem("token"));
    // console.log("token",token)

    if (token) {
      config.headers.set("Authorization", token);
      // config.headers.set('Authorization', `Bearer ${token}`);
    }

    requests.push(config);
    return config;
  },
  (error: AxiosError<ErrorResponseData>): Promise<never> => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    store.dispatch(setLoading(false));
    return response;
  },
  (error: AxiosError<ErrorResponseData>): Promise<never> => {
    const errorResponse = error.response?.data;
    const status = error.response?.status;
    const currentPath = window.location.pathname;

    if (
      currentPath !== "/market" &&
      currentPath !== "/fees" &&
      currentPath !== "/fees/" &&
      // currentPath !== "/spot-trade" &&
      currentPath !== "/market/" &&
      // currentPath !== "/spot-trade/" &&
      ((status === 401 &&
        errorResponse?.message?.toLowerCase() === "you are not authorized.") ||
        (status === 401 &&
          errorResponse?.message?.toLowerCase() ===
            "invalid token or expired!") ||
        (status === 403 &&
          errorResponse?.message?.toLowerCase() ===
            "invalid token or expired!") ||
        (status === 419 &&
          errorResponse?.message?.toLowerCase() === "please login again!"))
    ) {
      // localStorage.clear();
      // store.dispatch(setUser(null));
      // store.dispatch(setLoggedIn(false));
      Danger(errorResponse?.message);
      if (store?.getState()?.user?.user?._id) {
        logoutUser(store?.getState()?.user?.user?._id);
      } else {
        localStorage.removeItem("token");
        localStorage.clear();
        store.dispatch(setUser(null));
        store.dispatch(setLoggedIn(false));
        window.location.href = "/login";
      }

      // window.location.href = "/login";
    }
    if (
      status === 403 &&
      errorResponse?.message === "You are blocked by admin."
    ) {
      Danger(errorResponse?.message);
    }
    store.dispatch(setLoading(false));
    return Promise.reject(error);
  }
);

export default request;
